const INLINE_SAFE_CONTENT_TYPES = new Set([
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'image/bmp',
  'text/plain',
]);

/**
 * Builds the SharePoint folder URL for a task. Returns null unless the result is an https URL on the
 * same origin as the configured root and still inside the root folder.
 */
export function buildSharePointTaskUrl(rootUrl: string, taskId: unknown): string | null {
  const id = String(taskId ?? '').trim();
  if (!rootUrl || !id) {
    return null;
  }

  try {
    const root = new URL(rootUrl);
    if (root.protocol !== 'https:') {
      return null;
    }

    const target = new URL(root.href + encodeURIComponent(id));
    const isInsideRoot =
      target.origin === root.origin && target.pathname.startsWith(root.pathname);

    return isInsideRoot ? target.href : null;
  } catch {
    return null;
  }
}

/**
 * Returns the normalised content type if it is safe to render inline in a new window on the app's
 * origin, otherwise null. Types that can run script (html, svg, xml) are intentionally excluded.
 */
export function getSafeInlineContentType(contentType: string | null | undefined): string | null {
  const normalised = (contentType ?? '').split(';')[0].trim().toLowerCase();
  return INLINE_SAFE_CONTENT_TYPES.has(normalised) ? normalised : null;
}
